
import { getNativeProxySington } from '@helpers/NativeProxy';


const jumpNative = async (extras = {}) => {
  const np = await getNativeProxySington('seewoCube').catch((e) => {});
  await np.asyncInvoke({
    name: 'postMessage',
    params: {
      command: 'command_route_page',
      extras
    }
  })
}

const postMessage = async (command: string, extras = {}) => {
  const np = await getNativeProxySington('seewoCube').catch((e) => {});
  const data = await np.asyncInvoke({
    name: 'postMessage',
    params: {
      command,
      extras
    }
  })
  return data;
}

const NativeInterface = {
  jumpNative,
  postMessage
}

export default NativeInterface;